import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/api";
import { Subscription } from "../types";
import { ApiError } from "@/lib/api";
import { useState, useEffect } from "react";

interface IState {
  subscription: Subscription | null;
  subscriptions: Subscription[] | null;
}
interface UseSubscriptionReturn extends IState {
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useSubscription(): UseSubscriptionReturn {
  const [subscriptionData, setSubscriptionData] = useState<IState>({
    subscription: null,
    subscriptions: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSubscription = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await apiClient.getSubscription();
      setSubscriptionData(data);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(
          `Failed to fetch subscription: ${err.message} (Code: ${err.code})`
        );
      } else {
        setError(
          err instanceof Error ? err.message : "Failed to fetch subscription"
        );
      }
      console.error("Error fetching subscription:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, []);

  return {
    ...subscriptionData,
    loading,
    error,
    refetch: fetchSubscription,
  };
}
